import type {Impressum} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useImpressum() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'impressumGlobal',
      depth: 1,
      draft: !!route.query.preview,
    })

    return result as Populated<Impressum>
  }

  return {fetch}
}
